function checkWizzyConfigAndUpdate() {
  if(window.innerWidth < 768) {
    window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      'dom': '.predictive-search.hidden-desk.hidden-tablet .predictive-search__input',
      'type': 'text'
    };
  } else {
    window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      'dom': '.predictive-search.hidden-tablet.hidden-pocket .predictive-search__input',
      'type': 'text'
    };
  }
  clearInterval(interval);
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);

const facetLabelConversionMap = new Map([
    ["Disponueshmëria", "Availability"],
    ["Çmimi", "Price"],
    ["Lloji i produktit", "Product Type"],
    ["Gjinia", "Gender"],
    ["Markat", "Brands"],
    ["Ngjyrat", "Colors"],
    ["Madhësia", "Size"],
    ["Sporti", "Sport"],
]);
const sortLabelConversionMap = new Map([
    ["Rëndësia", "Relevance"],
    ["Më të Shiturat", "Bestseller"],
    ["Çmimi: nga më i ulëti te më i larti", "Price: low to high"],
    ["Çmimi: nga më i larti te më i ulëti", "Price: high to low"],
    ["A-Z", "A-Z"],
    ["Z-A", "Z-A"],
    ["Data: nga më e reja te më e vjetra", "Date: recent to old"],
    ["Data: nga më e vjetra te më e reja", "Date: old to recent"],
]);
const questionConversionMap = new Map([
    ["Filtro sipas ngjyrës:", "Filter by color:"],
    ["Filtro sipas madhësisë:", "Filter by size:"],
]);
function initEN(data){
        const isArabic = window.Shopify.locale === "en";
        if(window.Shopify.locale == "en") {
             data.search.configs.general.searchEndpoint="/en/pages/search";
             window.wizzyConfig.credentials = {
                "apiKey": "d1hDendMOC9zYll5NldSQnpPaEhNSVVWZGswczhPZ21CSzF5NEdaRzNFYmQvU0RjY0Qyc2dNc1kxdFA4L21vQWZhZzdKM05XOWM4MTd2ZTZEWXA2Y0JZUTdtWnZiaGRNVGljbHpnYVQzaXc9",
                "storeId": "539fd716f5dc11f0a76b0a0c8095feae"
            }
          
            data.search.configs.facets.configs.forEach(item => {
                if (facetLabelConversionMap.has(item.label)) {
                    item.label = facetLabelConversionMap.get(item.label);
                }
            });
            data.search.configs.sorts.configs.forEach(item => {
                if (sortLabelConversionMap.has(item.label)) {
                    item.label = sortLabelConversionMap.get(item.label);
                }
            });
            if(data.autocomplete && data.autocomplete.menu) {
                data.autocomplete.menu.brands.title = "Brand";
                data.autocomplete.menu.categories.title = "CATEGORIES";
                data.autocomplete.menu.others.title = "POPULAR SUGGESTIONS";
                data.autocomplete.topProducts.title = "أعلى المنتجات";
                data.search.view.templates.literals.emptySearchResultPageTitle = "لم نتمكن من العثور على أي نتائج!";
            }
            document.body.classList.add("wizzy-ar-language");
            data?.gridFilters?.filters?.forEach(item => {
                if (questionConversionMap.has(item.question)) {
                    item.question = questionConversionMap.get(item.question);
                }
              }
            )
        }
}


const availableSizeStrings = [
    "2XS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
    "0",
    "27/30",
    "31/34",
    "35/38",
    "39/42",
    "43/46",
    "47/50",
    "25/26",
    "27/28",
    "29/30",
    "31/32",
    "32/33",
    "33/34",
    "35/36",
    "37/38",
    "39/40",
    "41/42",
    "43/44",
    "45/46",
    "47/48",
    "1",
    "2",
    "3",
    "4",
    "5",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "50",
    "52",
    "6 Ans",
    "8 Ans",
    "12 Ans",
    "14 Ans",
    "10-11 Ans / 141-148 cm",
    "10-11 Ans / 141-150 cm",
    "12 Mois / 73-75 cm",
    "12-13 Ans / 149-159 cm",
    "12-13 Ans / 151-160 cm",
    "14-15 Ans / 160-166 cm",
    "14-15 Ans / 161-172 cm",
    "18 Mois / 76-81 cm",
    "2-3 Ans / 89-95 cm",
    "24 Mois / 82-88 cm",
    "2XL / W38 L31",
    "3-4 Ans / 96-102 cm",
    "3XL / W41 L31",
    "4-5 Ans / 103-112 cm",
    "5-6 Ans / 113-122 cm",
    "6 Mois / 61-69 cm",
    "7-8 Ans / 123-130 cm",
    "8-9 Ans / 131-140 cm",
    "ADULTE",
    "L / W33 L29",
    "L / W33 L31",
    "M / W30 L29",
    "M / W30 L31",
    "S / W28 L29",
    "S / W28 L31",
    "Taille unique",
    "UNIQUE",
    "XL / W35 L31",
    "XS / W26 L28",
    "XS / W26 L30"
];
let kosovoMultipleLanguage = window.wizzySettings?.kosovoMultipleLanguage || false;
console.log('Kosovo Multiple Language:', kosovoMultipleLanguage);

function formatPrice(amount, currency = "USD", locale = "en-US", useCodeInsteadOfSymbol = false) {
  if (typeof amount === "string") {
    amount = parseFloat(amount.replace(/,/g, ""));
  }

  // Safety: if parsing fails, default to 0
  if (isNaN(amount)) amount = 0;

  // Format the number without decimals
  let formattedNumber = new Intl.NumberFormat(locale, {
    minimumFractionDigits: kosovoMultipleLanguage ? 2 : 0,
    maximumFractionDigits: kosovoMultipleLanguage ? 2 : 0
  }).format(amount);
  
  if(kosovoMultipleLanguage){
    formattedNumber = amount.toFixed(2).replace(".", ",");
  }  
  // Return formatted output
  if (useCodeInsteadOfSymbol) {
    return `${currency} ${formattedNumber}`;
  }

  // Default to normal currency style
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
  }).format(amount);
}
function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = Math.floor(filterHeight / lineHeight) - 1;

          const toggleText = toggleBtn.querySelector("span");

          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
            if (toggleText) toggleText.textContent = window.wizzySettings.moreLabel;
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              if (toggleText) toggleText.textContent = window.wizzySettings.lessLabel;
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              if (toggleText) toggleText.textContent = window.wizzySettings.moreLabel;
            }
          });
        }
      });
    }
  }
}
function getRatingStarsHtml(rating, maxStars = 5) {
  
  var container = "";
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 >= 0.25 && rating % 1 < 0.75;
  const totalStars = hasHalf ? fullStars + 1 : Math.round(rating);

  for (let i = 0; i < fullStars; i++) {
    container += `
      <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star   rating__star rating__star--full" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="currentColor"></path>
      </svg>
    `;
  }

  if (hasHalf) {
    container += `
     <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star-half   rating__star rating__star--half" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="url(#rating-star-gradient-half)"></path>
      </svg>
    `;
  }

  for (let i = totalStars; i < maxStars; i++) {
    container += `
     <svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star   rating__star rating__star--empty" viewBox="0 0 14 13">
        <path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="#3643BA66"></path>
      </svg>
    `;
  
  }
  return container;
}
function waitForInputAndAttach() {
  const input = document.getElementsByClassName('.predictive-search__input.wizzy-search-input');
  // if (!input) {
  //   return setTimeout(waitForInputAndAttach, 100);
  // }

  // input.addEventListener('focus', () => {
  //   document.body.classList.add('wizzyMobileAutoComplete');
  // });

  // input.addEventListener('blur', () => {
  //   document.body.classList.remove('wizzyMobileAutoComplete');
  // });
}
 waitForInputAndAttach();
window.addEventListener('scroll', function () {
    const searchBar = window.innerWidth > 768 ? 
      document.querySelector(".header__inline-navigation .header__search-bar .predictive-search__input") : 
      document.querySelector(".header__search-bar.hidden-desk.hidden-tablet .predictive-search__input");
    const wizzyAutoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

    if (!searchBar || !wizzyAutoComplete) return;

    const searchBarRect = searchBar.getBoundingClientRect();
    const topPosition = searchBarRect.top + searchBarRect.height;
    wizzyAutoComplete.style.top = `${topPosition}px`;
});



window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
        if(kosovoMultipleLanguage){
            initEN(data);
        }
      data.store.currency.symbol = '';
      data.search.configs.pagination.appendInExistingList = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      data.filters.configs.layout = "v1";
       data.common.view.templates.literals.sortBy = window.wizzySettings.sortByLabel;
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1025) {
        data.search.configs.general.noOfProducts = 25;
      }
      if(window.innerWidth < 768) {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          'dom': '.predictive-search.hidden-desk.hidden-tablet .predictive-search__input',
          'type': 'text'
        };
      } else {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          'dom': '.predictive-search.hidden-tablet.hidden-pocket .predictive-search__input',
          'type': 'text'
        };
      }
      

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
        if(kosovoMultipleLanguage){
            initEN(data);
        }
      data.store.currency.symbol = '';
      data.search.configs.pagination.appendInExistingList = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      data.filters.configs.layout = "v1";
       data.common.view.templates.literals.sortBy = window.wizzySettings.sortByLabel;
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1025) {
        data.search.configs.general.noOfProducts = 25;
      }
      if(window.innerWidth < 768) {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          'dom': '.predictive-search.hidden-desk.hidden-tablet .predictive-search__input',
          'type': 'text'
        };
      } else {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          'dom': '.predictive-search.hidden-tablet.hidden-pocket .predictive-search__input',
          'type': 'text'
        };
      }
      // data.common.lazyDOMConfig.searchInputIdentifiers.push({
      //   'dom': '.header .predictive-search__input',
      //   'type': 'text'
      // });

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
       if(kosovoMultipleLanguage){
        if(window.Shopify.locale !== "en")
      {
        data.topProductsTitle = window.wizzySettings.topProductsLabel;
        data.seeMoreLabel = window.wizzySettings.seeMoreLabel;
        } else{
        data.topProductsTitle = "Best products" ;
        data.seeMoreLabel = "See all results";
      }
     } else {
         data.topProductsTitle = window.wizzySettings.topProductsLabel;
         data.seeMoreLabel = window.wizzySettings.seeMoreLabel;
        }
     
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (payload) {
      if (
        (payload.api === "search" || payload.api === "filter") &&
        Array.isArray(payload.response.payload.facets)
      ) {
        
        payload.response.payload.facets.forEach((facet) => {
          // Sort and capitalize labels for list facets

          if (facet.type === "list" && Array.isArray(facet.data)) {
            facet.data.forEach((item) => {
              if (typeof item.label === "string") {
                item.label =
                  item.label.charAt(0).toUpperCase() +
                  item.label.slice(1).toLowerCase();
              }
            });
            facet.data.sort((a, b) => a.label.localeCompare(b.label));
          }
          if (facet.key === "product_color_hexa_tag") {
            
            facet.data.forEach((item) => {
              item.data = {
                value: item.label,
                swatch: {
                  type: "visual",
                  value: item.label,
                },
              };
            });

            
          }
        });
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
    const isEnglish = window.Shopify.locale === "en";
      data.forEach((product) => {
        if(kosovoMultipleLanguage){
        if (isEnglish && product.url && !product.url.includes('/en/')) {
                const url = new URL(product.url, window.location.origin);
                product.url = `${url.origin}/en${url.pathname}`;
        }
    }
         
        product.hasZeroRating = false;
        if(product.sellingPrice){
          product.sellingPrice = formatPrice(product.sellingPrice,window.wizzySettings.currency,window.wizzySettings.locale,true)
        }
        if(product.price)
        {
          product.price= formatPrice(product.price,window.wizzySettings.currency,window.wizzySettings.locale,true)
        }
        let attributes = product.attributes;
        attributes.forEach((attribute) => {
         
          
          if (attribute.id === "product_handle") {
            product.handle = attribute.values[0].value[0];
          }
          if (attribute.id === "product_variant_prices" && attribute.values.length > 1) {
            product.hasToShowQuickView = true;
            
          }
          if (attribute.id === "product_ratings_count_reviews") {
            product.totalReviews = attribute.values[0].value[0];
          }
          if (attribute.id === "product_product_rating_reviews") {
            product.ratingStars = getRatingStarsHtml(attribute.values[0].value[0]);
            product.hasZeroRating = true;            
            product.avgRatings = attribute.values[0].value[0];
          }
        });

        
      });
      const wizzyEl = document.querySelector(".wizzy-main-content");
      if (wizzyEl) {
        let sibling = wizzyEl.nextElementSibling;
        while (sibling) {
          if (sibling.classList.contains("shopify-section")) {
            sibling.style.display = "none";
          }
          sibling = sibling.nextElementSibling;
        }
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        facets.forEach((facet) => {
          // if (facet.key === "product_color_hexa_tag") {
          //   facet.data.forEach((item) => {
          //     item.isSwatch = true;
          //     item.isURLSwatch = false;
          //     item.isVisualSwatch = true;
          //     item.swatchValue = item.data.value;
          //   });
          // }
          if (facet.key === "sizes") {
            const sizeOrderMap = {};
            availableSizeStrings.forEach((size, index) => {
              sizeOrderMap[size.toUpperCase()] = index;
            });
            facet.data = facet.data.slice().sort((a, b) => {
              const aVal = a.key.toUpperCase();
              const bVal = b.key.toUpperCase();
              
              const aIndex = sizeOrderMap.hasOwnProperty(aVal) ? sizeOrderMap[aVal] : Infinity;
              const bIndex = sizeOrderMap.hasOwnProperty(bVal) ? sizeOrderMap[bVal] : Infinity;
              
              // If both not in the map, keep original order
              if (aIndex === Infinity && bIndex === Infinity) return 0;
              return aIndex - bIndex;
            });
            
          }
        });
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      

      const facetList = document.querySelector(
        ".wizzy-facet-body.facet-body-inStock .wizzy-facet-list"
      );

      if (facetList) {
        const items = Array.from(
          facetList.querySelectorAll(".wizzy-facet-list-item")
        );

        // Update label text first
        items.forEach((el) => {
          const labelEl = el.querySelector(".facet-item-label-value");
          if (!labelEl) return;

          const text = labelEl.textContent.trim().toLowerCase();
          if (text === "in stock" && window.wizzySettings?.inStockLabel) {
            labelEl.textContent = window.wizzySettings.inStockLabel;
          } else if (
            text === "out of stock" &&
            window.wizzySettings?.outOfStockLabel
          ) {
            labelEl.textContent = window.wizzySettings.outOfStockLabel;
          }
        });

        // Sort ascending by updated label text
        items.sort((a, b) => {
          const aLabel =
            a
              .querySelector(".facet-item-label-value")
              ?.textContent.trim()
              .toLowerCase() || "";
          const bLabel =
            b
              .querySelector(".facet-item-label-value")
              ?.textContent.trim()
              .toLowerCase() || "";
          return bLabel.localeCompare(aLabel);
        });

        // Clear and re-append sorted items
        facetList.innerHTML = "";
        items.forEach((item) => facetList.appendChild(item));
      }
      document
        .querySelectorAll(
          ".product-item__image-wrapper.product-item__image-wrapper--multiple img"
        )
        .forEach((img) => {
          if (img.src.includes("https://via.placeholder.com/360x360")) {
            img.src = img.src
              .replace(
                "https://via.placeholder.com/360x360",
                "https://placehold.co/360x360/3642b8/FFF?font=roboto&text=Decathlon"
              )
              .replace(/;width=\d+/g, "");
          }

          if (
            img.srcset &&
            img.srcset.includes("https://via.placeholder.com/360x360")
          ) {
            img.srcset = img.srcset
              .replaceAll(
                "https://via.placeholder.com/360x360",
                "https://placehold.co/360x360/3642b8/FFF?font=roboto&text=Decathlon"
              )
              .replace(/;width=\d+/g, "");
          }
        });
      document
        .querySelectorAll(
          ".wizzy-selected-facet-list-item-label .facet-item-label-value"
        )
        .forEach((el) => {
          const nodes = Array.from(el.childNodes);
          nodes.forEach((node) => {
            if (
              node.nodeType === Node.TEXT_NODE &&
              node.textContent.trim().toLowerCase() === "out of stock"
            ) {
              node.textContent = window.wizzySettings.outOfStockLabel;
            }
            if (
              node.nodeType === Node.TEXT_NODE &&
              node.textContent.trim().toLowerCase() === "in stock"
            ) {
              node.textContent = window.wizzySettings.inStockLabel;
            }
          });
        });
   
     try {
        const tooltips = document.querySelectorAll('.noUi-tooltip');
        
        tooltips.forEach((tooltip) => {
          setTimeout(() => {
            const rawValue = tooltip.textContent.replace(/[^\d.-]/g, ''); 
            const numericValue = parseFloat(rawValue);
      
            if (!isNaN(numericValue)) {
              tooltip.textContent = formatPrice(numericValue, window.wizzySettings.currency, window.wizzySettings.locale,true);
            }
          }, 100);
    });

    const handleElement = document.querySelector('.noUi-handle');

    const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.attributeName === 'aria-valuemax' || mutation.attributeName === 'aria-valuemin') {
        const tooltips = document.querySelectorAll('.noUi-tooltip');

        tooltips.forEach((tooltip) => {
          setTimeout(() => {
            const rawValue = tooltip.textContent.replace(/[^\d.-]/g, '');
            const numericValue = parseFloat(rawValue);

            if (!isNaN(numericValue)) {
              tooltip.textContent = formatPrice(numericValue, window.wizzySettings.currency, window.wizzySettings.locale,true);
            }
          }, 100);
        });
      }
    }
  });

    observer.observe(handleElement, { attributes: true });
  
  } catch (e) {
    // console.error("Tooltip formatting error:", e);
  }

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      gridFiltersToggleOnOverflow();

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      gridFiltersToggleOnOverflow();
    

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      payload.minQueryLength = 1;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      const searchDrawer = document.querySelector("#search-drawer");
      if (searchDrawer) {
       searchDrawer.removeAttribute("open");
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      
      payload.minQueryLength = 1;
      
      return payload;
    }
  );

  document.addEventListener("click", function (event) {
    const innerLabel = event.target.closest(".wizzy-common-select-innerlabel");
    if (innerLabel) {
      const container = innerLabel.closest(".wizzy-common-select-container");
      if (container) {
        const options = container.querySelector(".wizzy-common-select-options");
        const overlay = container.querySelector(".wizzy-common-select-overlay");

        if (options) options.style.display = "none";
        if (overlay) overlay.style.display = "none";
      }
    }
  });

  // document
  //   .querySelector(".header__inline-navigation .predictive-search__input")
  //   ?.addEventListener("click", () => {
  //     setTimeout(() => {
        
  //       const input = document.querySelector(
  //         ".predictive-search__input.wizzy-search-input"
  //       );

  //       if (input) {
  //         input.click();
  //         input.blur();
  //         input.focus();
  //         input.click();
  //       }
  //     }, 500); // slight delay if input renders after animation
  //   });
};